export default {
  methods: {
    formatCardNumber: (value) => {
      if (!value) return '';
      const cleanValue = String(value).replace(/\s/g, '');
      return cleanValue.replace(/(.{4})/g, '$1 ').trim();
    },
  },
};
